import { render, staticRenderFns } from "./InfoImageAlert.vue?vue&type=template&id=27dcd4a0&"
import script from "./InfoImageAlert.vue?vue&type=script&lang=js&"
export * from "./InfoImageAlert.vue?vue&type=script&lang=js&"
import style0 from "./InfoImageAlert.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports